const CUSTOM_EVENT = {
  // Fires on every user change of currency in CurrencySwitch.jsx that causes
  // local state to update to selected currency where needed.
  CURRENCY_CHANGE: 'currencyChange',
  // Fires on every user change of currency in CurrencySwitch.jsx that causes
  // local state to update to selected culture where needed.
  CULTURE_CHANGE: 'cultureChange',
  // Dispatched by CompareItemButton components when a user adds or removes an id from the compare id list.
  // Contains the item ID. The Compare CTA Component listens for this event to update the compare id list.
  COMPARE_KEY_UPDATE: 'compareKey:update',
  // Dispatched by the Compare CTA Component after the compare id list has been updated (added or removed an id).
  // Contains the updated compare id list array. Compare Button components listen for this event to update their selected state.
  COMPARE_KEY_LIST_UPDATED: 'compareKey:listUpdated',
  // Dispatched when loading results in Package Search to trigger a re-render of compare item list
  // to maintain state or re-mounted compare buttons
  GET_COMPARE_BUTTON_STATE_ON_REMOUNT: 'getCompareButtonStateOnRemount',
  // Dispatched by accordions when open or closed
  // Contains the accordions label. Accordions listen for this event and will be toggled if the label matches.
  PACKAGE_COMPARE_ACCORDION_TOGGLED: 'packageCompareAccordionToggled',
};

export default CUSTOM_EVENT;
